const MediaAdviserTypeEnum = Object.freeze({
    FEES: 'FEES',
    FEES_CHARGES_STATEMENT: 'FEES_CHARGES_STATEMENT',
    TERMS: 'TERMS'
});

export default MediaAdviserTypeEnum;
